import PropTypes from "prop-types";
import {React, useRef} from 'react'

//Chakra
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
  useDisclosure,
} from "@chakra-ui/react";

const DeleteButton = props => {

  // VARIABLES ===============================================================
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef(null);
  
  //Props
  const button_color_scheme = props?.buttonColor ?? "green";
  const textTransform = props?.textTransform ?? "uppercase";
  const { 
    func, 
    dialog,
    buttonText,
  } = props

  // FUNCTIONS ==============================================================

  return (
    <>
      <Button bg="#520701" py='4px' px='8px'
        mx='3px' borderColor='#D75147' borderWidth='2px' rounded='md'
        _hover={{ bg: '#830E04', borderColor: 'white' }}
        textTransform={textTransform}
        fontWeight={"extrabold"}
        backgroundColor={dialog.button_color}
        onClick={onOpen}
      >
        {buttonText}
      </Button>
      <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {dialog.header}
            </AlertDialogHeader>

            <AlertDialogBody>
              {dialog.body}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button
                colorScheme={button_color_scheme}
                onClick={() => {
                  func();
                  onClose();
                }}
                ml={3}
              >
                {dialog.confirm}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}

DeleteButton.propTypes = {
  buttonText: PropTypes.string,
  dialog: PropTypes.object,
  func: PropTypes.func,
};

export default DeleteButton;